import { CalendarMonth } from "@mui/icons-material";
import { Box, Paper, Stack } from "@mui/material";
import dayjs from "dayjs";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import TitleWithIcon from "../../../../components/display/TitleWithIcon";
import BookingModal from "../../../../components/modals/bookingModalComponents/components/BookingModal";
import BookingModalContext from "../../../../components/modals/bookingModalComponents/context/BookingModalContext";
import CustomDialog from "../../../../components/wrappers/CustomDrawer";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import ToggleDrawer from "../../../../contexts/ToggleDrawer";
import useUser from "../../../../hooks/useUser";
import DesktopAppointement from "../DesktopAppointement";

const getValidDateFromParams = (dateParam) => {
  if (!dateParam) return null;

  const parsed = dayjs(dateParam, "DD/MM/YYYY", true);

  if (!parsed.isValid()) return null;

  if (parsed.isBefore(dayjs().startOf("day"))) return null;

  return parsed.toDate();
};

export default function AdminDesktopCalendar() {
  const { t } = useTranslation();
  const { roles, currentClinic } = useUser();
  const { mode } = useContext(ThemeContext);
  const light = String(mode) === "light";
  const [searchParams] = useSearchParams();
  return (
    <Paper
      sx={{
        p: 2,
        height: "100%",
        minHeight: 735,
        bgcolor: light ? "white" : "",
      }}
    >
      <Stack direction={"row"} mb={2} justifyContent={"space-between"}>
        <TitleWithIcon title={"AppointmentsCalendar"}>
          <CalendarMonth />
        </TitleWithIcon>
        <Box>
          <ToggleDrawer>
            <CustomDialog
              color="info"
              buttonSize={"small"}
              buttonVariant="contained"
              buttonMessage={t(
                roles?.adminOrEmployee
                  ? "BookAppointmentClinic"
                  : "BookAppointment",
              )}
              maxWidth={!currentClinic.id ? "xs" : "lg"}
              testId={"appointment.booking-form.calendar"}
            >
              <BookingModalContext key={"header-booking-context"}>
                <BookingModal
                  key={"header-booking-modal"}
                  selectedDate={getValidDateFromParams(
                    searchParams.get("date"),
                  )}
                />
              </BookingModalContext>
            </CustomDialog>
          </ToggleDrawer>
        </Box>
      </Stack>
      <Calendar />
    </Paper>
  );
}

function Calendar() {
  return (
    <ToggleDrawer>
      <DesktopAppointement showTitle={false} />
    </ToggleDrawer>
  );
}
